import { Download } from "lucide-react";
import { DIRECTING_RESUME_URL } from "@/lib/data";

export default function Directing() {
    return (
        <section
            id="directing"
            data-testid="directing-section"
            className="bg-[#1A1A1A] text-[#F7F5F0] py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid grid-cols-12 gap-6 md:gap-12">
                    <div className="col-span-12 md:col-span-7">
                        <p className="eyebrow !text-[#C67C4E]">§ 04</p>
                        <h2 className="font-serif-display text-5xl md:text-6xl lg:text-7xl mt-3 leading-[0.92] text-[#F7F5F0]">
                            Shaping
                            <br />
                            <span className="italic font-light">
                                the stage.
                            </span>
                        </h2>
                    </div>
                    <div className="col-span-12 md:col-span-5 flex flex-col justify-end gap-6">
                        <p className="text-base md:text-lg text-[#F7F5F0]/70 font-light leading-relaxed">
                            Trained under Tony Award winner David Cromer.
                            Former Intern Director for DirectorsLabChicago.
                            Work spans new plays, musical theatre development,
                            readings and educational stages.
                        </p>
                        <a
                            href={DIRECTING_RESUME_URL}
                            download="Vickie-Daignault-Directing-Resume.pdf"
                            target="_blank"
                            rel="noreferrer"
                            data-testid="download-directing-resume"
                            className="inline-flex items-center justify-center gap-2 border border-[#F7F5F0] text-[#F7F5F0] px-6 py-3 text-xs tracking-[0.22em] uppercase hover:bg-[#F7F5F0] hover:text-[#1A1A1A] transition-colors duration-300 w-fit"
                        >
                            <Download size={14} />
                            Full Directing Résumé
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
